import React from 'react';

import { InputAction, ImportExportIcon } from '@gogame/components';

import {
  useFiltersStateManager,
  isEqualFilterValues,
} from '../FiltersStateManager';

const Equalize = ({ path, basePath, fontSize }) => {
  const { getFilterValue, setFilterValue } = useFiltersStateManager();

  const baseValue = getFilterValue(basePath);
  const value = getFilterValue(path);

  const handleEqualizeFilter = () => {
    setFilterValue(path, baseValue);
  };

  const filterEqualized = isEqualFilterValues(baseValue, value);

  return (
    <InputAction
      icon={<ImportExportIcon />}
      tooltip={'Equalize filter to the first value'}
      onClick={handleEqualizeFilter}
      disabled={filterEqualized}
      fontSize={fontSize}
    />
  );
};

export default Equalize;
